(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["import-coverage"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ml-import-coverage')) {
    customElements.define('ml-import-coverage', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.physicalVariants = new Set((this.dataset.physicalVariants || '').split(','));
        this.onVariantChange = (event) => {
          if (event.target.name === 'id') this.updateVisibility();
        };
        this.form?.addEventListener('change', this.onVariantChange);
        this.updateVisibility();
      }

      disconnectedCallback() {
        this.form?.removeEventListener('change', this.onVariantChange);
      }

      updateVisibility() {
        const variantId = this.form?.querySelector('input[name="id"]')?.value;
        this.hidden = !this.physicalVariants.has(variantId);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
